<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <template slot="header">
            <i class='fa fa-align-justify'></i> 예외파일
          </template>
          <b-form-group>
            <b-form-file v-model="file" @change="bs_file" :disabled="lock" v-show="!lock"></b-form-file>
          </b-form-group>
          <div>
            <b-form-group>
              <label for="ph_md5">MD5 해쉬</label>
              <b-form-input md=5 type="text" id="ph_md5" v-model="model.hash" :disabled="lock"></b-form-input>
            </b-form-group>
            <b-form-group>
              <label for="ph_cause">설명</label>
              <b-form-textarea :rows="3" v-model="model.cause" id="descph_causeript"></b-form-textarea>
            </b-form-group>
          </div>
          <hr/>
          <b-button size="sm" variant="success" @click="save"> 저장 </b-button>
          <b-button size="sm" variant="danger" @click="confirm=true"> 삭제  </b-button>
          <b-button size="sm" class="float-right" variant="primary" @click="list"> 목록으로 </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="삭제"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      선택한 정보를 삭제하시겠습니까? <br>
      이 작업은 되돌릴 수 없습니다.
    </b-modal>
  </div>
</template>

<script>
import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { Api } from '@/service';
import md5 from 'md5';
import forge from 'node-forge';

export default {
  data : () => {
    return {
      file : undefined,
      confirm: false,
      add: false,
      lock: true,
      model : { hash : '', cause : '' }
    }
  },
  methods: {
    list() { this.$emit('refresh'), this.$router.push({ name: 'hash'}); },
    bs_file(file) {
      let fr = new FileReader();
      let f = file.target.files[0];
      if(!f) { return; } else { this.model.cause = f.name; }

      if(f.size > 5242880) { this.$toastr.w('최대 파일 크기를 초과합니다.'); return; }
      console.log(fr.result)
      fr.onload = x => { this.model.hash = forge.md5.create().update(forge.util.createBuffer(fr.result).data).digest().toHex(); }
      fr.readAsArrayBuffer(f);
    },
    async remove() {
      try {
        let rs = await Api.WSFinder_Call('hash', 'delete', { id : this.model.id })
        if(!rs.error) {
            this.$toastr.s('removed.', this.$route.name);
          } else {
            console.log("remove", 'failed', rs.reason, this.model.id)
            this.$toastr.e('delete', "failed")
          }
          this.list(); this.$emit("refresh");
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    async get(id = this.$route.params.id) {
      if (id == 'add' | id == 'edit') { this.lock = false; return; }
      try {
        let rs = await Api.WSFinder_Call('hash', 'detail', { id : id })
        this.model = Object.assign({}, this.model, rs.body)
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    async save() {
      if(!(this.model.hash || '').trim()) { return this.$toastr.e('파일 선택은 필수입니다.'); }
      try {
        await Api.WSFinder_Call('hash', this.model.id ? 'update' : 'insert', this.model);
        this.$toastr.s('저장되었습니다'); this.$emit('refresh');
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
      this.lock = true;
    },
  },
  watch: { '$route' (to, from) { this.get(to.params.id); console.log(`from : ${from}`); } },
  created: function() { console.log('hash.detail.vue', 'created'); },
  destroyed: function() { console.log('hash.detail.vue', 'destroyed'); },
  mounted: function() { console.log('hash.detail.vue', 'mounted'); this.get(this.$route.params.id); },
}
</script>
